// Sukut ko'rinish NECHTA qatorni yashirganini o'lchaydi (ADR-033 §5).
//
// ⚠️ NEGA SANOQ SERVERDAN, MIJOZDAN EMAS. Ro'yxat sahifalangan: joriy
// sahifadagi qatorlarni sanash «25 dan 18 tasi» degan mahalliy va
// YOLG'ON son berardi. Shuning uchun yashiringan son AYNAN yopilgan
// holat bo'yicha alohida so'rov bilan olinadi (`size=1`, faqat `total`
// kerak) — server esa holat aniq berilganda `includeClosed` ni
// e'tiborsiz qoldiradi, ya'ni son yopilganlarning O'ZIDAN chiqadi.

import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type { PageResult } from './DataTable'
import { toQueryParams, type TableState } from './tableState'

export interface ClosedHidden {
  /** Ro'yxatda ko'rinayotgan JAMI qator (joriy sahifa emas) */
  shown: number
  /** Sukut ko'rinish yashirgan qator */
  hidden: number
}

export interface ClosedHiddenOptions<Row> {
  /** `DataTable` ga berilgan kalitning O'ZI — sabab quyida */
  queryKey: readonly unknown[]
  state: TableState
  fetchPage: (state: TableState, signal: AbortSignal) => Promise<PageResult<Row>>
  countClosed: (state: TableState, signal: AbortSignal) => Promise<number>
  /** Sukut ko'rinishdagina hisoblanadi: holat tanlansa yashirilgan qator yo'q */
  enabled: boolean
}

/**
 * Ko'rinayotgan va yashiringan qatorlar soni.
 *
 * <h2>⚠️ BIRINCHI SO'ROV QAYTA YUBORILMAYDI</h2>
 * Kalit {@code DataTable} nikidan AYNAN nusxa
 * ({@code [...queryKey, toQueryParams(state)]}) — React Query ikkala
 * kuzatuvchiga bitta javobni beradi. Kalit ajralib ketsa nuqson jim
 * bo'lardi: ikkinchi, keraksiz so'rov ketardi va nishondagi son
 * jadvalnikidan bir zum orqada qolardi.
 *
 * <h2>⚠️ YASHIRINGANLAR KALITIDA SAHIFA YO'Q</h2>
 * Son butun ro'yxatniki, ya'ni sahifa almashganda u o'zgarmaydi. Kalitga
 * sahifani qo'shish har bosishda bir xil javob uchun yangi so'rov
 * yuborardi.
 */
export function useClosedHidden<Row>({
  queryKey,
  state,
  fetchPage,
  countClosed,
  enabled,
}: ClosedHiddenOptions<Row>): ClosedHidden | null {
  const shown = useQuery({
    queryKey: [...queryKey, toQueryParams(state)],
    queryFn: ({ signal }) => fetchPage(state, signal),
    placeholderData: keepPreviousData,
    enabled,
  })

  const hidden = useQuery({
    queryKey: [...queryKey, 'closed-count', state.search.trim(), state.filters],
    queryFn: ({ signal }) => countClosed(state, signal),
    placeholderData: keepPreviousData,
    enabled,
  })

  if (!enabled || shown.data === undefined || hidden.data === undefined) return null
  return { shown: shown.data.total, hidden: hidden.data }
}
